import { Dispatch, SetStateAction, useState } from 'react';

import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { Button, Checkbox, Menu, MenuItem, Typography } from '@mui/material';

export default function ConvocationDocumentType({
  INITIAL_STATE,
  state,
  setState,
  data,
  disabled,
}: {
  INITIAL_STATE: any;
  state: any;
  setState: Dispatch<SetStateAction<any>>;
  data?: any;
  disabled: boolean;
}) {
  const documentTypes = [
    'Carta Consulta',
    'Consulta Formal',
    'Edital de Convocação',
  ];
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCheck = (documentType: string | string[]) => {
    setState((prev: any) => {
      if (Array.isArray(documentType)) {
        return {
          ...prev,
          documentType:
            state.documentType.length === INITIAL_STATE.documentType.length
              ? []
              : documentType,
        };
      }

      const updatedType = state.documentType.includes(documentType)
        ? state.documentType.filter((s: string) => s !== documentType)
        : state.documentType.concat(documentType);

      return {
        ...prev,
        documentType: updatedType.sort(),
      };
    });
  };

  return (
    <>
      <Button
        id="lock-button"
        aria-controls={open ? 'lock-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        endIcon={
          <ExpandMoreRoundedIcon
            sx={{ transform: open ? 'rotate(180deg)' : 'unset' }}
          />
        }
        onClick={handleClickMenu}
        disabled={disabled}
        sx={(theme) => ({
          color:
            state.documentType.length > 0 &&
            state.documentType.length !== INITIAL_STATE.documentType.length
              ? theme.palette.primary.main
              : '#4F4F4F',
        })}>
        Espécie de assembleia:{' '}
        {state.documentType.length === INITIAL_STATE.documentType.length
          ? 'Todos'
          : state.documentType.length > 0
            ? `+${state.documentType.length}`
            : 'Nenhum'}
      </Button>
      {data && (
        <Menu
          id="lock-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'lock-button',
            role: 'listbox',
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          PaperProps={{
            style: {
              maxHeight: '40dvh',
            },
          }}
          aria-disabled={disabled}>
          <MenuItem
            sx={{
              display: 'flex',
              alignItems: 'center',
              '&.Mui-selected': {
                backgroundColor: '#F1F1F1',
              },
            }}
            selected={
              state.documentType.length === INITIAL_STATE.documentType.length
            }
            onClick={() => handleCheck(documentTypes)}>
            <Checkbox
              checked={
                INITIAL_STATE.documentType.length === state.documentType.length
              }
              inputProps={{ 'aria-label': 'checkbox' }}
              color="secondary"
              size="small"
            />
            <Typography fontSize={14} fontWeight={700} color={'#000'}>
              Todas
            </Typography>
          </MenuItem>
          {documentTypes.map((type, index) => (
            <MenuItem
              key={index}
              sx={{ display: 'flex', alignItems: 'center' }}
              onClick={() => handleCheck(type)}>
              <Checkbox
                checked={state.documentType.includes(type)}
                inputProps={{ 'aria-label': 'checkbox' }}
                color="primary"
                size="small"
              />
              <Typography fontSize={12} fontWeight={600} color={'#000'}>
                {type}
              </Typography>
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
}
